$(document).on('submit', '.add_to_cart_form', function (e){
    e.preventDefault();
    const product_url = window.location;
    const form = $(this);
    const button = $('.add_to_cart_button', this);
    button.attr('disabled', true);
    addToCart(form, button, product_url);
});

function addToCart(form, button, product_url){
    const buttonText = button.html();
    button.html('<img class="loader" src="'+LOADER+'" alt="ajax loader">');
    $.post(product_url, form.serialize() + '&_wp_http_referer=' + product_url, function (result){

        let error = $('.notif.danger.woocommerce-message', result);
        button.attr('disabled', false);
        if(typeof error !== 'undefined'){
            //console.log(error);
            if(typeof error[0] !== 'undefined'){
                notif('danger', error[0].innerText);
                button.html(buttonText);
                return false;
            }
        }

        /* let mini-cart reinit */
        update_mini_cart_count(result);
        update_mini_cart_content(false, result, true);
        mini_cart_init = false;

        let add_to_cart_modal = $('.js-modal-add-to-cart-data', result);
        if(add_to_cart_modal.length){
            $('.js-modal-add-to-cart-data').replaceWith(add_to_cart_modal);
        }

        if( $('#add-to-cart-modal').length ){

            if(form.hasClass('additional-sale')){
                var imgtodrag = $('.additional-sale-image[data-product-id="'+ $('input[name="add-to-cart"]', form).val() +'"]').first().attr('src');
                $('.add-to-cart .product-title').text( $('.additional-sale-product[data-product-id="'+ $('input[name="add-to-cart"]', form).val() +'"]').text()  );
                $('.add-to-cart .product-quantity').text(1+'x');
            }else{
                var imgtodrag = $('.product-detail__main-img').first().attr('src');
                $('.add-to-cart .product-quantity').text($('.quantity.quantity-buttons input').val()+'x');
                $('.add-to-cart .product-title').text($('h1').text());
            }
            if (imgtodrag && imgtodrag.length) {
                $('.add-to-cart .product-image').attr('src', imgtodrag);
            }

            $('.add-to-cart .product-price').text($('.single-product ins .formated-price').text());
            modal_open( $('.add-to-cart') );

        }else{

            notif('success', $('#item_added_to_cart_text').val());

            if($(window).width() >= 992){
                var cart = $('.basket_icon_wrapper');
                if(form.hasClass('additional-sale')){
                    var imgtodrag = $('.additional-sale-image[data-product-id="'+ $('input[name="add-to-cart"]', form).val() +'"]').first();
                }else{
                    var imgtodrag = $('.product-detail__main-img').first();
                }

                if (imgtodrag.length) {
                    let imgclone = imgtodrag.clone()
                        .removeClass('h-auto w-100 h-100')
                        .offset({
                            top:  imgtodrag.offset().top,
                            left: imgtodrag.offset().left
                        })
                        .css({
                            'opacity': '0.5',
                            'position': 'absolute',
                            'height': '150px',
                            'width': '150px',
                            'z-index': '100'
                        })
                        .appendTo($('body'))
                        .animate({
                            'top': cart.offset().top + 10,
                            'left': cart.offset().left + 10,
                            'width': '75px',
                            'height': '75px'
                        });

                    imgclone.animate({
                        'width': 0,
                        'height': 0
                    }, function (){
                        $(this).detach()
                    });

                }
            }
        }

        button.html(buttonText);

        /* on cart upsale  */
        if($('body').hasClass('cart-page')){
            $('#update_cart').click();
        }

        // vyvolá funkciu ak existuje
        if (typeof onAddToCart == 'function') {
            onAddToCart();
        }
    });
}
